module.exports = __webpack_public_path__ + "files/7f56ddfac4fa25c9f79723f36f25c000.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/arvo-italic-webfont.eot
// module id = 379
// module chunks = 60